import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store'
import Api from './api'
import api from '@/api/entry'

Vue.config.productionTip = false

// 拉取微信配置信息
api.user.getWxConfig({ url: window.location.href }).then((res) => {
  let { result } = res
  if (result && JSON.stringify(result) !== '{}') {
    window.sessionStorage.setItem('wxc', JSON.stringify(result))
  }
})

Vue.use(Api)
Vue.use(Vant)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

/**
 * todo 设置页面title
 */
document.title = '人民日报发行服务号'

/**
 * todo 引入微信openapi方法
 */
let script = document.createElement('script')
script.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js'
document.body.append(script)

/**
 * todo 解决ios的Safari的输入框自动放大
 * @description 追加两个meta头信息
 */
let metaForIos1 = document.createElement('meta')
metaForIos1.content = 'yes'
metaForIos1.name = 'apple-mobile-web-app-capable'
let metaForIos2 = document.createElement('meta')
metaForIos2.name = 'viewport'
metaForIos2.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
document.getElementsByTagName('head')[0].appendChild(metaForIos1)
document.getElementsByTagName('head')[0].appendChild(metaForIos2)
